import React from "react";
import PropTypes from "prop-types";
import moment from "moment";
import momentTimezone from "moment-timezone";
import AttributeToOpen from "components/RestaurantDetails/AttributeToOpen.js";

// react component for creating dynamic tables
// @material-ui/core components
// import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
// import style from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
// import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

const sorter = {
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
  sunday: 7
};

function isOpen(openings, timezoneRestaurant) {
  const now = moment().format();
  const nowTimezone = momentTimezone(now);
  const restaurantDate = nowTimezone.clone().tz(timezoneRestaurant);
  // console.log(restaurantDate);
  const restaurantDay = restaurantDate.format("dddd");
  const foundDayOpen = openings.find(
    element => element.weekDay.toLowerCase() === restaurantDay.toLowerCase()
  );
  let open1 = false;
  // const open2 = false;
  // console.log('foundDayOpen', foundDayOpen);
  if (foundDayOpen) {
    // check today
    if (
      foundDayOpen &&
      foundDayOpen.hoursRange &&
      foundDayOpen.hoursRange.some(
        el => el.hourFrom === "00:00" && el.hourTo === "00:00"
      )
    ) {
      return true;
    }
    open1 = foundDayOpen.hoursRange.some(h => {
      const restaurantDateNew = restaurantDate.format("YYYY-MM-DD");
      let timeZone;
      if (restaurantDate.format().indexOf("+") !== -1) {
        timeZone = `+${restaurantDate.format().split("+")[1]}`;
      } else {
        timeZone = `-${restaurantDate.format().split("-")[3]}`;
      }
      const newDateF = moment(
        `${restaurantDateNew}T${h.hourFrom}:00${timeZone}`
      );
      let newDateT = moment(`${restaurantDateNew}T${h.hourTo}:00${timeZone}`);
      if (parseInt(h.hourFrom, 10) > parseInt(h.hourTo, 10)) {
        const tomorrow = moment()
          .add(1, "days")
          .format("YYYY-MM-DD");
        newDateT = moment(`${tomorrow}T${h.hourTo}:00${timeZone}`);
      }
      return (
        !restaurantDate.isBefore(newDateF) && restaurantDate.isBefore(newDateT)
      );
    });
  }
  return open1;
}

function isEverOpen(openings) {
  if (!openings) {
    return false;
  }
  if (openings.some(element => element.hoursRange.length > 0)) {
    return true;
  }
  return false;
}

export default function RestaurantInfo(props) {
  const restaurant = props.restaurant;

  const getClosingDays = () => {
    const restaurant = props.restaurant;
    const days = {
      sunday: "domenica",
      monday: "lunedì",
      tuesday: "martedì",
      wednesday: "mercoledì",
      thursday: "giovedì",
      friday: "venerdì",
      saturday: "sabato"
    };
    const displayedDays = [];
    if (restaurant.closingDays && restaurant.closingDays.length > 0) {
      const closings = restaurant.closingDays.sort((a, b) => {
        const day1 = a.toLowerCase();
        const day2 = b.toLowerCase();
        return sorter[day1] > sorter[day2];
      });
      displayedDays.push(
        <span
          style={{ marginTop: "15px" }}
          key={`closing-days-${restaurant.name}`}
        >
          Chiuso:{" "}
        </span>
      );
      displayedDays.push(
        closings.map((el, index) => (
          <span key={`single-closing-day-${index.toString()}`}>
            {days[el]}
            {index < closings.length - 1 ? ", " : null}
          </span>
        ))
      );
    }
    return displayedDays;
  };

  const getTodayTime = () => {
    const restaurant = props.restaurant;
    const index = restaurant.openings.findIndex(
      el =>
        el.weekDay ===
        moment()
          .format("dddd")
          .toLowerCase()
    );

    if (
      restaurant.openings.length === 0 ||
      (restaurant.closingDays &&
        restaurant.closingDays.includes(
          moment()
            .format("dddd")
            .toLowerCase()
        ))
    ) {
      return (
        <span key={"restaurant-is-closed"} className="RestaurantInfo-crew">
          Oggi chiuso
        </span>
      );
    }
    // console.log(index, restaurant.openings, moment().format('dddd'));
    if (index > -1) {
      if (
        restaurant.openings[index].hoursRange.some(
          el => el.hourFrom === "00:00" && el.hourTo === "00:00"
        )
      ) {
        return (
          <span
            itemProp="openingHours"
            className="RestaurantInfo-crew"
            key={"openings-time-all-day"}
          >
            Aperto tutto il giorno
          </span>
        );
      }
      return restaurant.openings[index].hoursRange.map((element, i) => (
        <span
          itemProp="openingHours"
          className="RestaurantInfo-crew"
          key={`openings-time-${i.toString()}`}
        >
          Dalle {element.hourFrom} alle {element.hourTo}
          {i < restaurant.openings[index].hoursRange.length - 1 ? ", " : null}
        </span>
      ));
    }
    return null;
  };

  const getAttributes = type => {
    const restaurant = props.restaurant;
    if (!restaurant.service) {
      restaurant.service = [];
    }
    let attributes = [];
    // const displayedAttributes = [];
    if (type === "categories") {
      const categories = [].concat(restaurant.categories);
      categories.shift();
      attributes = categories;
    } else if (type === "idealFor") {
      attributes = restaurant.idealForEventTypes;
    } else if (type === "service") {
      attributes = restaurant.service
        .filter(el => el._id.type === "service")
        .map(element => element._id);
    } else if (type === "menu") {
      attributes = restaurant.service
        .filter(el => el._id.type === "menu")
        .map(element => element._id);
    } else if (type === "location") {
      attributes = restaurant.service
        .filter(el => el._id.type === "location")
        .map(element => element._id);
    } else if (type === "hotel") {
      attributes = restaurant.service
        .filter(el => el._id.type === "hotel")
        .map(element => element._id);
    } else if (type === "meal") {
      attributes = restaurant.service
        .filter(el => el._id.type === "meal")
        .map(element => element._id);
    } else {
      attributes = restaurant.typesOfFood;
    }
    const displayedAttributes = attributes.map((element, index) => (
      <span key={`attribute-${type}-${index.toString()}`}>
        {element && element[`label_it`] ? element[`label_it`] : ""}
        {index < attributes.length - 1 ? ", " : null}
      </span>
    ));
    return displayedAttributes;
  };

  const getOpenableAttributes = type => {
    const restaurant = props.restaurant;
    if (!restaurant.service) {
      restaurant.service = [];
    }
    let attributes = [];
    switch (type) {
      case "service":
        attributes = restaurant.service.filter(el => el._id.type === "service");
        break;
      case "menu":
        attributes = restaurant.service.filter(el => el._id.type === "menu");
        break;
      case "location":
        attributes = restaurant.service.filter(
          el => el._id.type === "location"
        );
        break;
      default:
        attributes = restaurant.service.filter(el => el._id.type === "service");
    }
    if (attributes.length > 0) {
      return attributes.map((el, index) => (
        <div key={`attribute-to-open-${type}-${index.toString()}`}>
          <AttributeToOpen
            attribute={el}
            fullWidth={type === "service" || type === "location"}
          />
        </div>
      ));
    }
    return null;
  };

  const getProducts = type => {
    let displayedProducts = "";
    const filteredProducts = props.restaurant.products.filter(
      product => product.title === type
    );
    if (filteredProducts.length > 0) {
      filteredProducts.forEach((element, index) => {
        displayedProducts += element.name;
        if (index !== filteredProducts.length - 1) {
          displayedProducts += ", ";
        }
      });
    }
    return displayedProducts;
  };

  const getSeatings = () => {
    const restaurant = props.restaurant;
    const seatings = restaurant.service.filter(
      el => el._id.type === "seatings"
    );
    if (seatings.length > 0) {
      return seatings.map(seat => (
        <div
          key={`restaurant-seating-${seat._id._id.toString()}`}
          style={{ width: "100%" }}
          className="attribute-to-open-container"
        >
          <div className="RestaurantInfo-crew" style={{ width: "initial" }}>
            <i
              className={`icon icon-${seat._id.icon}  attribute-to-open-icon`}
              style={{ lineHeight: "18px" }}
            />
            {seat.description} {seat._id[`label_it`]}
          </div>
        </div>
      ));
    } else if (
      restaurant.numberOfIndoorSeats ||
      restaurant.numberOfOutdoorSeats
    ) {
      return (
        <div>
          {restaurant.numberOfIndoorSeats &&
          restaurant.numberOfIndoorSeats > 0 ? (
            <div
              style={{ width: "100%" }}
              className="attribute-to-open-container"
            >
              <div className="RestaurantInfo-crew" style={{ width: "initial" }}>
                <i
                  className={"icon icon-Indoor-seats-24 attribute-to-open-icon"}
                  style={{ lineHeight: "18px" }}
                />
                {restaurant.numberOfIndoorSeats}
                {" posti al coperto"}
              </div>
            </div>
          ) : null}
          {restaurant.numberOfOutdoorSeats &&
          restaurant.numberOfOutdoorSeats > 0 ? (
            <div
              style={{ width: "100%" }}
              className="attribute-to-open-container"
            >
              <div className="RestaurantInfo-crew" style={{ width: "initial" }}>
                <i
                  className={
                    "icon icon-Outside-seating-24 attribute-to-open-icon"
                  }
                  style={{ lineHeight: "18px" }}
                />
                {restaurant.numberOfOutdoorSeats}
                {" posti fuori"}
              </div>
            </div>
          ) : null}
        </div>
      );
    }
    return null;
  };

  const getPaymentMethods = () => {
    const methods = [];
    props.restaurant.paymentMethods.forEach((element, index) => {
      let iconImage = "icon-Visa-24";
      switch (element) {
        case "Visa":
          iconImage = "icon-Visa-24";
          break;
        case "Mastercard":
          iconImage = "icon-Master-card-24";
          break;
        case "AECard":
          iconImage = "icon-American-express-24";
          break;
        case "SICard":
          iconImage = "icon-nexi-24";
          break;
        case "Nexi":
          iconImage = "icon-nexi-24";
          break;
        case "DIERSCard":
          iconImage = "icon-diners-club-24";
          break;
        case "Bancomat":
          iconImage = "icon-pago-bancomat-24";
          break;
        case "Cash":
          iconImage = "icon-cash-24";
          break;
        case "CashOnly":
          iconImage = "icon-cash-24";
          break;
        case "MealTicket":
          iconImage = "icon-ticket-24";
          break;
        default:
          iconImage = "icon-cash-24";
      }
      methods.push(
        <i
          key={`restaurant-payment-method-${index.toString()}`}
          className={`icon ${iconImage}`}
          style={
            index !== props.restaurant.paymentMethods.length - 1
              ? { marginRight: "10px", fontSize: "40px" }
              : { fontSize: "40px" }
          }
        />
      );
    });
    return methods;
  };

  const getDescription = () => {
    let description = "";
    const restaurant = props.restaurant;
    const i = restaurant.description.findIndex(el => el.language === "it");
    if (i >= 0) {
      description = restaurant.description[i].message;
    }
    return description;
  };

  const getTags = () => {
    const tags = props.restaurant.tags;
    return tags.map((el, index) => (
      <div
        key={`restauarnt-tag-${index.toString()}`}
        className="restaurant-details-tag"
      >
        {el}
      </div>
    ));
  };

  const getHolidays = () => {
    const holidays = props.restaurant.holidays;
    return holidays.map((element, index) => {
      if (element.dateFrom && element.dateTo && element.description) {
        const dateA = moment();
        const dateB = moment(element.dateTo);
        let dateFrom = "";
        const dateDay = moment(element.dateFrom)
          .format("DD")
          .toString();
        const dateMonth = moment(element.dateFrom)
          .format("MM")
          .toString()
          .toLowerCase();
        const dateYear = moment(element.dateFrom)
          .format("YYYY")
          .toString();
        dateFrom = `${dateDay} ${dateMonth} ${dateYear}`;
        let dateTo = "";
        const dateDay2 = moment(element.dateTo)
          .format("DD")
          .toString();
        const dateMonth2 = moment(element.dateTo)
          .format("MM")
          .toString()
          .toLowerCase();
        const dateYear2 = moment(element.dateTo)
          .format("YYYY")
          .toString();
        dateTo = `${dateDay2} ${dateMonth2} ${dateYear2}`;
        if (dateA.isBefore(dateB)) {
          return (
            <div
              key={`restaurant-holidays-${index.toString()}`}
              className="RestaurantInfo-crew"
            >
              <div>
                <span className="RestaurantInfo-label-description">Dal</span>
                {dateFrom}
                <span className="RestaurantInfo-label-description">al</span>
                {dateTo}
              </div>
              <div>
                <span className="RestaurantInfo-label-description">per</span>
                {element.description}
              </div>
            </div>
          );
        }
        return null;
      }
      return null;
    });
  };

  let today = null;
  let timezoneRestaurant = "Europe/Rome"; // TODO change with restaurant Timezone
  if (
    restaurant &&
    restaurant.address &&
    restaurant.address.timezone &&
    restaurant.address.timezone.timeZoneId
  ) {
    timezoneRestaurant = restaurant.address.timezone.timeZoneId;
  }
  let isOpenNow = false;
  if (restaurant.openings) {
    today = restaurant.openings.find(
      el =>
        el.weekDay ===
        moment()
          .format("dddd")
          .toLowerCase()
    );

    if (isOpen(restaurant.openings, timezoneRestaurant)) {
      isOpenNow = true;
    }
  }
  if (
    restaurant.closingDays &&
    restaurant.closingDays.includes(
      moment()
        .format("dddd")
        .toLowerCase()
    )
  ) {
    isOpenNow = false;
  }
  if (
    restaurant.holidays &&
    restaurant.holidays.some(
      el =>
        moment().isBefore(el.dateTo) && moment(el.dateFrom).isBefore(moment())
    )
  ) {
    isOpenNow = false;
  }
  // console.log("restauranttttttttttttt", restaurant);

  return (
    <>
      <div className="restaurant-head-main-info">
        <div>
          {(restaurant.openings && isEverOpen(restaurant.openings)) ||
          (restaurant.closingDays && restaurant.closingDays.length > 0) ? (
            // && today && today.hoursRange.length > 0
            <div className="RestaurantInfo-opening">
              {restaurant.openings && isEverOpen(restaurant.openings) ? (
                <div style={{ marginBottom: "15px" }}>
                  Adesso:{" "}
                  {isOpenNow ? (
                    <span style={{ color: "#b6c81e" }}>Aperto</span>
                  ) : (
                    <span style={{ color: "#e6792b" }}>Chiuso</span>
                  )}
                  {restaurant.openings &&
                  restaurant.openings.length > 0 &&
                  today &&
                  today.hoursRange &&
                  today.hoursRange.length !== 0 ? (
                    <div>({getTodayTime()})</div>
                  ) : null}
                </div>
              ) : null}{" "}
              {restaurant.closingDays && restaurant.closingDays.length > 0
                ? getClosingDays()
                : null}
            </div>
          ) : null}
          {restaurant.shortDescription &&
          restaurant.shortDescription.length > 0 &&
          restaurant.shortDescription.some(el => el.language === "it") ? (
            <p
              className="RestaurantInfo-crew"
              style={{ display: "inline-block" }}
            >
              {
                restaurant.shortDescription[
                  restaurant.shortDescription.findIndex(
                    el => el.language === "it"
                  )
                ].message
              }
            </p>
          ) : null}
          <div className="restaurant-other-information">
            {restaurant.service &&
            restaurant.service.length > 0 &&
            restaurant.service.filter(el => el._id.type === "menu").length >
              0 ? (
              <div
                className="RestaurantInfo-crew"
                style={{ float: "left", marginBottom: "15px" }}
              >
                <span className="RestaurantInfo-label-description">Menu</span>
                <div style={{ marginTop: "10px" }}>
                  {getOpenableAttributes("menu")}
                </div>
              </div>
            ) : null}

            {restaurant.products &&
            restaurant.products.some(el => el.title === "home products") ? (
              <div className="RestaurantInfo-food">
                <span className="RestaurantInfo-label-description">
                  Piatti della casa
                </span>{" "}
                {getProducts("home products")}
              </div>
            ) : null}
            {restaurant.products &&
            restaurant.products.some(el => el.title === "best products") ? (
              <div className="RestaurantInfo-food">
                <span className="RestaurantInfo-label-description">
                  Piatti speciali
                </span>{" "}
                {getProducts("best products")}
              </div>
            ) : null}
            {restaurant.products &&
            restaurant.products.some(el => el.title === "km0 products") ? (
              <div className="RestaurantInfo-food">
                <span className="RestaurantInfo-label-description">
                  Prodotti a km0
                </span>{" "}
                {getProducts("km0 products")}
              </div>
            ) : null}
            {restaurant.service &&
            restaurant.service.length > 0 &&
            restaurant.service.filter(
              el => el._id.type === "location" || el._id.type === "seatings"
            ).length > 0 ? (
              <div className="RestaurantInfo-food-half">
                <span className="RestaurantInfo-label-description">
                  Location
                </span>
                <div style={{ marginTop: "10px" }}>
                  {getOpenableAttributes("location")}
                  {getSeatings()}
                </div>
              </div>
            ) : null}
            {restaurant.service &&
            restaurant.service.length > 0 &&
            restaurant.service.filter(el => el._id.type === "service").length >
              0 ? (
              <div className="RestaurantInfo-food-half">
                <span className="RestaurantInfo-label-description">
                  {restaurant.type === "hotel" ? "altri servizi" : "servizi"}
                </span>
                <div style={{ marginTop: "10px" }}>
                  {getOpenableAttributes("service")}
                </div>
              </div>
            ) : null}
            {restaurant.paymentMethods &&
            restaurant.paymentMethods.length > 0 ? (
              <div
                className="RestaurantInfo-crew"
                style={{ display: "inline-block" }}
              >
                <span className="RestaurantInfo-label-description">
                  Metodi di pagamento
                </span>
                <br /> {getPaymentMethods()}
              </div>
            ) : null}
            {restaurant.description &&
            restaurant.description.length > 0 &&
            restaurant.description.some(el => el.language === "it") ? (
              <p
                className="RestaurantInfo-crew"
                style={{ width: "100%", display: "inline-block" }}
              >
                <span className="RestaurantInfo-label-description">
                  Descrizione
                </span>
                <br />
                <span>{getDescription()}</span>
              </p>
            ) : null}
            {restaurant.tags && restaurant.tags.length > 0 ? (
              <div
                className="RestaurantInfo-crew"
                style={{
                  float: "left",
                  marginBottom: "20px",
                  marginTop: "20px"
                }}
              >
                <div
                  className="RestaurantInfo-label-description"
                  style={{ float: "left", marginRight: "5px" }}
                >
                  {"Tags "}
                </div>{" "}
                {getTags()}
              </div>
            ) : null}
            {restaurant.holidays &&
            restaurant.holidays.length > 0 &&
            restaurant.holidays.some(el => moment().isBefore(el.dateTo)) ? (
              <div className="RestaurantInfo-crew">
                <span className="RestaurantInfo-label-description">Ferie</span>
                <div>{getHolidays()}</div>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
}

RestaurantInfo.propTypes = {
  restaurant: PropTypes.object.isRequired
};
